var jquery = require("jquery");
var cookie = require("jquery.cookie");
window.$ = window.jQuery = jquery;
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;
import ScrollOut from "scroll-out";

ScrollOut({
	cssProps: {
		viewportY: true,
	},
});


var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.headerContainer').outerHeight();



// READY

$(function () {

	console.log('Website proudly by Imagic Creative');

	$("[data-required]").each(function (index) {
		$(this).attr('required', true);
	});

	setInterval(() => {
		var scrollTop = $(window).scrollTop();
		if (!$('body[mobile-aria-expanded="true"]').length) {
			headerColourSwitch(scrollTop);
		}
		// console.log('THEME ' + $('.relevant-slider-section').attr('data-theme'))
	}, 300);

	
	// TABS

	$('[data-tab-nav]').on('click', function() {
		var tab = $(this).attr('data-tab-nav');
		var theme = $(this).attr('data-theme');
		// console.log('tab ' + tab)
		var section = $(this).closest('section');
		if (theme) {
			section.attr('data-theme', theme);
		}
		section.find('[data-tab-nav]').removeClass('btn-fill');
		$(this).addClass('btn-fill');
		section.find('[data-tab]').removeAttr('data-tab-active');
		section.find('[data-tab="' + tab + '"]').attr('data-tab-active','');
		var icon = section.find('.icon');
		if (icon.length) {
			section.find('[data-icon-for]').removeAttr('data-icon-active');
			section.find('[data-icon-for="' + tab + '"]').attr('data-icon-active','');
		}
	});


	// ACCORDION

	$(document).on('click', '.accordion:not(.is-open)', function(e) {
		$(this).addClass('is-open');
		var content = $(this).parent().find('.accordion-content');
		var maxH = content.find('div').outerHeight() + 40;
		content.css('max-height', maxH);
	});
	$(document).on('click', '.accordion.is-open', function(e) {
		$(this).removeClass('is-open');
		var content = $(this).parent().find('.accordion-content');
		content.removeAttr('style');
	});


	// MENU
	$('.btn-menu-mobile-ghost').on("click", function(e) {
		$('.btn-menu-mobile').trigger('click');
	});
	$('.btn-menu-mobile').on("click", function(e) {
		e.stopPropagation();
		$(this).toggleClass('open');
		var mobMenu = $('aside.mobile-menu');
		$('header').removeAttr('data-header-dark');
		$('header').attr('data-header-light','');
		$('header .search-block').removeClass('open');
		$('body').attr('data-search-expanded', 'false');
		if ($(this).hasClass('open')) {
			$('body').attr('mobile-aria-expanded', true);
			$('body:not(.body-checkout)').attr('data-body-theme', 'black');
			$('.header-dark').removeAttr('style');
			mobMenu.attr('aria-expanded', true);
			if ($('#molecules').length) {
				$('#molecules').hide();
			}
		} else {
			$('body').attr('mobile-aria-expanded', false);
			$('body:not(.body-checkout)').attr('data-body-theme', mobMenu.attr('data-body-theme'));
			mobMenu.attr('aria-expanded', false);
			if ($('#molecules').length) {
				$('#molecules').show();
			}
		}
	});
	$('.menu-block-desktop .btn').on("click", function(e) {
		e.stopPropagation();
		$('.menu-block-desktop .btn').toggleClass('open');
		if ($('.menu-block-desktop .btn').hasClass('open')) {
			$('.menu-block-desktop .btn span').html('Close');
		} else {
			$('.menu-block-desktop .btn span').html('Menu');
		}
	});
	$(document).on("click", function(e) {
		$('.menu-block-desktop .btn').removeClass('open');
		$('.menu-block-desktop .btn span').html('Menu');
	});


    resizeVideo();
	

});


// SCROLL

$(window).on('scroll', function(e) {

	didScroll = true;

	var scrollTop = $(window).scrollTop();
	headerColourSwitch(scrollTop);

});


// RESIZE

$(window).on('resize', function() {

	resizeVideo();

});

function headerColourSwitch(scrollTop) {
	if ($('body[data-search-expanded="true"]').length || $('header[data-header-checkout]').length) {
		return false;
	}
	var mainOffset = $('main').offset().top - scrollTop;
	var bodyTheme = $('body').attr('data-body-theme');
	var header = $('body:not(.body-checkout) header');
	if ($('body.homepage').length) {
		if (scrollTop > 150) {
			$('body').addClass('smaller-logo');
		} else {
			$('body').removeClass('smaller-logo');
		}
	} else {
		if (scrollTop > 51) {
			$('body').addClass('smaller-logo');
		} else {
			$('body').removeClass('smaller-logo');
		}
	}
	if (mainOffset <= 0) {
		var sectionWhite = $('[data-theme="white"][data-scroll="in"]');
		var sectionBlack = $('[data-theme="black"][data-scroll="in"]');
		if (sectionWhite.length) {
			var sectionWhiteOffset = sectionWhite.offset().top - scrollTop;
			if (sectionWhiteOffset >= -20) {
				var inset = sectionWhiteOffset;
				if (inset > 94) {
					inset = 94;
				}
				if (inset > 45 && inset <= 94) {
					header.attr('data-header-light','');
					header.removeAttr('data-header-dark');
				} else {
					header.removeAttr('data-header-light');
					header.attr('data-header-dark','');
				}
			} else {
				header.removeAttr('data-header-light');
				header.attr('data-header-dark','');
			}
		} else if (sectionBlack.length) {
			var sectionBlackOffset = sectionBlack.offset().top - scrollTop;
			if (sectionBlackOffset <= -20) {
				header.attr('data-header-light','');
				header.removeAttr('data-header-dark');
			}
		} else {
			header.attr('data-header-light','');
			header.removeAttr('data-header-dark');
		}
	} else {
		if (bodyTheme == 'white') {
			header.attr('data-header-dark','');
			header.removeAttr('data-header-light');
		} else {
			header.attr('data-header-light','');
			header.removeAttr('data-header-dark');
		}
	}
}





$('[data-scroll-up]').on('click', function() {
	$('html, body').animate({scrollTop: 0}, 'slow');
});
$('[data-type="more"]').on('click', function() {
	var nextSection = $(this).closest('section').siblings('section').first();
	$('html, body').animate({scrollTop: nextSection.offset().top}, 'slow');
});





///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PODCAST POPUP

$(document).on('click','.card-podcasts', function(e) {
	// console.log('podcast card click')
	var podcastPopupIframe = $('iframe[data-popup-iframe]');
    e.stopPropagation();
    e.preventDefault();
    var id = $(this).attr('data-id');
	var src = siteUrl + '/podcast-popup/' + id;
	console.log(src);
	podcastPopupIframe.attr('src', src);

	setTimeout(() => {	
		podcastPopupIframe.attr('data-visible', 'true');
		$('body').attr('data-popup-expanded', 'true');
	}, 200);
	return false;

});

$(document).on('click', '[data-podcast-popup-close]', function(e) {
	// console.log('data-podcast-popup-close')
	var podcastPopupIframe = window.parent.$('iframe[data-popup-iframe]');
	podcastPopupIframe.attr('data-visible', 'false');
	window.parent.$('body').attr('data-popup-expanded', 'false');
	var src = siteUrl + '/podcast-popup';
	podcastPopupIframe.attr('src', src);
	return false;
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////






///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TOPIC POPUP

$(document).on('click','.card-lesson-round[data-id]', function(e) {
	// console.log('topic card click')
	var topicPopupIframe = $('iframe[data-popup-iframe]');
    e.stopPropagation();
    e.preventDefault();
    var id = $(this).attr('data-id');
	var src = siteUrl + '/topic-popup/' + id;
	console.log(src);
	topicPopupIframe.attr('src', src);

	setTimeout(() => {	
		topicPopupIframe.attr('data-visible', 'true');
		$('body').attr('data-popup-expanded', 'true');
	}, 300);
	return false;

});

$(document).on('click', '[data-topic-popup-close]', function(e) {
	// console.log('data-topic-popup-close')
	var topicPopupIframe = window.parent.$('iframe[data-popup-iframe]');
	topicPopupIframe.attr('data-visible', 'false');
	window.parent.$('body').attr('data-popup-expanded', 'false');
	var src = siteUrl + '/topic-popup';
	topicPopupIframe.attr('src', src);
	return false;
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////






///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SEARCH POPUP

$(document).on('click','header .search-block', function(e) {
	$('.btn-menu-mobile.open').trigger('click');
	if ($(this).hasClass('open')) {
		$(this).removeClass('open');
		$('body').attr('data-search-expanded', 'false');
	} else {
		$(this).addClass('open');
		$('body').attr('data-search-expanded', 'true');
		$('body').addClass('header-stuck');
		$('body').addClass('smaller-logo');
		$('header').removeAttr('data-header-dark', '');
		$('header').attr('data-header-light', '');
		$('.ais-SearchBox-input').focus();
	}
	return false;

});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////






///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PRODUCT BACK LINK

$(document).ready(function() {
	if (!$('#backLink').length) {
		return false;
	}
	var referrer = document.referrer;
	var backLink;

	if (referrer.includes('/shop?')) {
		backLink = referrer + '#shop';
		$('#backLink').attr('href', backLink);
	} else {
		// backLink = '/shop#shop';
	}

});

$('#backLink').on('click', function() {
	var href = $(this).attr('href');
	if (href == '#') {
		history.back();
	}
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////






///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EDIT BUTTON FOR ADMINS ONLY

$(function () {
    fetchUserAccess();
});
async function fetchUserAccess() {
    var page = window.page;
	if (!page) {
		return false;
	}
    try {
        const response = await $.ajax({
            type: 'get',
            url: '/dynamic/admin?page=' + page,
        });
        if (response) {
            var url = response;
            var newUrl;
            if (url.includes('site=')) {
                newUrl = url + '&ni-block=';
            } else {
                newUrl = url + '?ni-block=';
            }
            var btn = `
                <a class="btn btn-yellow btn-fill btn-edit" href="` + newUrl + `" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.424 12.282l4.402 4.399-5.826 1.319 1.424-5.718zm15.576-6.748l-9.689 9.804-4.536-4.536 9.689-9.802 4.536 4.534zm-6 8.916v6.55h-16v-12h6.743l1.978-2h-10.721v16h20v-10.573l-2 2.023z"/></svg>
                </a>
            `;

            $('main').append(btn);
            
            var sections = document.querySelectorAll('[data-ni-block-id]');
            sections.forEach(function (section) {
                var niBlock = section.getAttribute('data-ni-block-id');
                var link = document.createElement('a');
                link.className = 'aria bg-purple-300 py-1 px-1 rounded-full absolute top-2 right-2 text-14 z-10 flex items-center';
                link.href = newUrl + niBlock + '#tab03--live-lesson';
                link.target = '_blank';
                link.innerHTML = '<svg class="w-4" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m14.523 18.787s4.501-4.505 6.255-6.26c.146-.146.219-.338.219-.53s-.073-.383-.219-.53c-1.753-1.754-6.255-6.258-6.255-6.258-.144-.145-.334-.217-.524-.217-.193 0-.385.074-.532.221-.293.292-.295.766-.004 1.056l4.978 4.978h-14.692c-.414 0-.75.336-.75.75s.336.75.75.75h14.692l-4.979 4.979c-.289.289-.286.762.006 1.054.148.148.341.222.533.222.19 0 .378-.072.522-.215z" fill-rule="nonzero" fill="currentColor"/></svg>';
                section.appendChild(link);
            });
        }
    } catch (error) {
        console.log('fetchUserAccess() error');
        console.log(error);
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////






///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// VIDEO

window.resizeVideo = function resizeVideo() {
	var $iframeHero = $('.hero-grid-block .video-container');
	if ($iframeHero.length) {
		var $iframeHeroEl = $iframeHero.children().first();
		var windowWidth = $iframeHeroEl.parent().parent().width();
		var windowHeight = $iframeHeroEl.parent().parent().height();
		// Calculate the aspect ratio of the iframe
		var aspectRatio = 16 / 9; // Standard for Vimeo; adjust if needed

		if (windowWidth / windowHeight > aspectRatio) {
			$iframeHeroEl.css({
				width: windowWidth,
				height: windowWidth / aspectRatio
			});
		} else {
			$iframeHeroEl.css({
				width: windowHeight * aspectRatio,
				height: windowHeight
			});
		}
	}
	var $iframeProduct = $('.card-product .video-container');
	if ($iframeProduct.length) {
		$iframeProduct.each(function() {
			var iframeProduct = $(this);
			var $iframeProductEl = iframeProduct.children().first();
			var windowWidth = $iframeProductEl.parent().parent().width();
			var windowHeight = $iframeProductEl.parent().parent().height();
			// Calculate the aspect ratio of the iframe
			var aspectRatio = 16 / 9; // Standard for Vimeo; adjust if needed
	
			if (windowWidth / windowHeight > aspectRatio) {
				$iframeProductEl.css({
					width: windowWidth,
					height: windowWidth / aspectRatio
				});
			} else {
				$iframeProductEl.css({
					width: windowHeight * aspectRatio,
					height: windowHeight
				});
			}
		})
	}
	var $iframeProductInfo = $('.column-gallery .video-container');
	if ($iframeProductInfo.length) {
		var $iframeProductInfoEl = $iframeProductInfo.children().first();
		var windowWidth = $iframeProductInfoEl.parent().parent().width();
		var windowHeight = $iframeProductInfoEl.parent().parent().height();
		// Calculate the aspect ratio of the iframe
		var aspectRatio = 16 / 9; // Standard for Vimeo; adjust if needed

		if (windowWidth / windowHeight > aspectRatio) {
			$iframeProductInfoEl.css({
				width: windowWidth,
				height: windowWidth / aspectRatio
			});
		} else {
			$iframeProductInfoEl.css({
				width: windowHeight * aspectRatio,
				height: windowHeight
			});
		}
	}
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////






///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PROMO POPUP

var promoPopupEl = $('aside.promo-popup');

$(function () {
	promoPopup();
});

$(window).on('resize', function() {
	promoPopup();
});

function promoPopup() {
	if (!promoPopupEl.length) {
		return false;
	}
    if (!$.cookie('promo-popup-hide') && promoPopupEl.length) {
		setTimeout(() => {
        	promoPopupEl.fadeIn().css('display', 'flex');
		}, 5000);
    }
}

$(document).on('click', '[data-promo-popup-close]', function(e) {
	promoPopupEl.attr('data-expanded', 'false');
	promoPopupEl.fadeOut();
	$('body').attr('data-popup-expanded', 'false');
	$.cookie('promo-popup-hide', true);
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////